import React, { useEffect } from "react";
import { Checkbox, Header, List } from "semantic-ui-react";
import { LayerObj } from "./Types";

interface Props {
  visibleLayers: LayerObj;
}

const LayersWidget = ({ visibleLayers }: Props) => {
  return (
    <div>
      <Header as="h4" style={{ margin: "0.5em" }}>
        Static Layers
      </Header>
      <List style={{ padding: "0 .5em" }}>
        <List.Item style={{ paddingBottom: ".5em" }}>
          <Checkbox
            style={{ width: "100%" }}
            label="Road Labels"
            defaultChecked={visibleLayers.road_labels.visible}
            onChange={(_e, i) => {
              visibleLayers.road_labels.visible = i.checked;
            }}
          />
        </List.Item>
        <List.Item style={{ paddingBottom: ".5em" }}>
          <Checkbox
            style={{ width: "100%" }}
            label="Parcel Lot Numbers"
            defaultChecked={visibleLayers.parcel_lot_numbers.visible}
            onChange={(_e, i) => {
              visibleLayers.parcel_lot_numbers.visible = i.checked;
            }}
          />
        </List.Item>
        <List.Item style={{ paddingBottom: ".5em" }}>
          <Checkbox
            style={{ width: "100%" }}
            label="E911 Address Points"
            defaultChecked={visibleLayers.e911_address_points.visible}
            onChange={(_e, i) => {
              visibleLayers.e911_address_points.visible = i.checked;
            }}
          />
        </List.Item>
        <List.Item style={{ paddingBottom: ".5em" }}>
          <Checkbox
            style={{ width: "100%" }}
            label="Historic Lot Lines"
            defaultChecked={visibleLayers.historic_lot_lines.visible}
            onChange={(_e, i) => {
              visibleLayers.historic_lot_lines.visible = i.checked;
            }}
          />
        </List.Item>
        <List.Item style={{ paddingBottom: ".5em" }}>
          <Checkbox
            style={{ width: "100%" }}
            label="Parcel Dimensions"
            defaultChecked={visibleLayers.parcel_dimensions.visible}
            onChange={(_e, i) => {
              visibleLayers.parcel_dimensions.visible = i.checked;
            }}
          />
        </List.Item>
        <List.Item style={{ paddingBottom: ".5em" }}>
          <Checkbox
            style={{ width: "100%" }}
            label="Parcel Labels"
            defaultChecked={visibleLayers.parcel_labels.visible}
            onChange={(_e, i) => {
              visibleLayers.parcel_labels.visible = i.checked;
            }}
          />
        </List.Item>
      </List>

      <Header as="h4" style={{ margin: "0.5em" }}>
        Identify Layers
      </Header>
      <List style={{ padding: "0 .5em" }}>
        <List.Item style={{ paddingBottom: ".5em" }}>
          <Checkbox
            style={{ width: "100%" }}
            label="Parcels"
            defaultChecked={visibleLayers.parcels.visible}
            onChange={(_e, i) => {
              visibleLayers.parcels.visible = i.checked;
            }}
          />
        </List.Item>
      </List>
    </div>
  );
};

export default LayersWidget;
